<div class="wrapper__progress__bar">
    <div class="wrapper__progress__bar__step--progress">
        <p [ngStyle]="{'width': percentage + '%' }"></p>
    </div>
    <div class="wrapper__progress__bar--label">
        <span>{{percentage}}%</span>
    </div>
</div>
